import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  ICreateOpenTitleSessionInput,
  ICreateOpenTitleSessionResult,
} from '@shared/models/orders';

import { MUTATION_ERROR_FRAGMENT } from '../errors.fragments';

export const CHECKOUT_SESSION_FRAGMENT = gql`
  fragment CheckoutSessionFragment on CheckoutSession {
    sessionId
    url
    expiresAt
  }
`;

export const CREATE_OPEN_TITLE_SESSION: TypedDocumentNode<
  ICreateOpenTitleSessionResult,
  ICreateOpenTitleSessionInput
> = gql`
  ${CHECKOUT_SESSION_FRAGMENT}
  ${MUTATION_ERROR_FRAGMENT}
  mutation createOpenTitleSession($input: CreateOpenTitleSessionInput!) {
    createOpenTitleSession(input: $input) {
      result {
        ...CheckoutSessionFragment
      }
      errors {
        ...ErrorFragment
      }
    }
  }
`;
